import { InfoDrawer } from '../info-drawer'

import type { DrawerControlProps } from '../drawer'
import type { Intent } from '../theme'

type Props = DrawerControlProps & {
  header?: React.ReactNode
  title?: React.ReactNode
  description?: React.ReactNode | undefined
  onConfirm: () => void
  onCancel?: () => void
  busy?: boolean | undefined
  intent?: Intent | undefined
  confirmLabel?: React.ReactNode
  cancelLabel?: React.ReactNode
}

export const ConfirmDrawer: React.FC<Props> = ({
  onOpenChange,
  open,
  header,
  title,
  description,
  busy,
  onConfirm,
  onCancel,
  intent,
  confirmLabel,
  cancelLabel,
}) => {
  const handleCancel = () => (onCancel ? onCancel() : onOpenChange?.(false))

  return (
    <InfoDrawer
      open={open}
      onOpenChange={onOpenChange}
      header={header}
      title={title}
      description={description}
      busy={busy}
      intent={intent}
      cancel={{
        label: cancelLabel,
        onClick: handleCancel,
      }}
      confirm={{
        label: confirmLabel,
        onClick: onConfirm,
      }}
    />
  )
}
